<template>
    <b-modal :id="$id('MarkModal_' + formType)" :visible="visible" centered no-close-on-backdrop no-close-on-esc scrollable size="lg">
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col class="text-left">
                    <h6>{{ $t(MarkField.Name) }}</h6>
                </b-col>
                <b-col class=" pr-0 p-1 pl-4 text-right">
                    <!-- $t('Close') / Fermer-->
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false; resetQuizz()" v-b-tooltip.hover :title="$t('Close')" />
                </b-col>
            </b-row>
        </template>

        <template v-if="quizz.Questions">
            <!-- {{ quizz.Questions }} -->
              <b-row class="p-2">
                <b-col>
                    <b-card v-for="(q, index) in quizz.Questions['BaseQuestions']" :key="index" no-body class="m-2 p-3" :style="generateVariantStyle(Variant)">
                        <b-form-group :label="quizz.Labels.find(x => x.Id == q.LabelRef).Value" label-class="font-weight-bold text-dark pt-0 pb-2"  >
                            <!-- Affichage des questions de type param -->
                            <template v-if="q.Type == 'param'">
                                <p>{{ getLabel(q, q.Param.LabelRef) }}</p>
                            </template>

                            <!-- Affichage des questions de type decreasingSum -->
                            <template v-else-if="q.Type == 'decreasingSum'">
                                <b-form-checkbox-group stacked v-model="questionSelections[q.Id]" plain>
                                    <b-form-checkbox v-for="i in q.Items" :key="i.Id" :value="i.Id">{{ getLabel(q, i.LabelRef) }}</b-form-checkbox>
                                </b-form-checkbox-group>
                            </template>

                            <!-- Affichage des questions de type radiobuttons -->
                            <template v-else-if="q.Type == 'radiobuttons'">
                                <b-form-radio-group stacked v-model="questionSelections[q.Id][0]" plain>
                                    <b-form-radio v-for="i in q.Items" :key="i.Id" :value="i.Id">{{ getLabel(q, i.LabelRef) }}</b-form-radio> 
                                </b-form-radio-group>
                            </template>

                            <!-- Affichage des questions de type conditionalradiobuttons -->
                            <template v-else-if="q.Type == 'conditionalradiobuttons'">
                                <b-form-radio-group stacked v-model="questionSelections[q.Id][0]" plain>
                                    <b-form-radio v-for="i in q.Items" :key="i.Id" :value="i.Id">{{ getLabel(q, i.LabelRef) }}</b-form-radio> 
                                </b-form-radio-group>
                            </template>

                            <!-- Affichage des questions de type checkboxes -->
                            <template v-else-if="q.Type == 'checkboxes'">
                                <b-form-checkbox-group stacked v-model="questionSelections[q.Id]" plain>
                                    <b-form-checkbox v-for="i in q.Items" :key="i.Id" :value="i.Id" >{{ getLabel(q, i.LabelRef) }}</b-form-checkbox>
                                </b-form-checkbox-group>
                            </template>

                            <!-- Affichage des questions de type conditionalcheckboxes -->
                            <template v-else-if="q.Type == 'conditionalcheckboxes'">
                                <b-form-checkbox-group stacked v-model="questionSelections[q.Id]" plain>
                                    <b-form-checkbox v-for="i in q.Items" :key="i.Id" :value="i.Id" >{{ getLabel(q, i.LabelRef) }}</b-form-checkbox>
                                </b-form-checkbox-group>
                            </template>
                        </b-form-group>
                    </b-card>
                </b-col>
              </b-row>
            
        </template>

        <!-- Pied de la modale (note + modulation + boutons annuler et valider) -->
        <template #modal-footer="{ok,close}">
            
            <b-row>
                <b-col cols="auto">
                    <b-form-input number readonly v-model="mark" :class="changeMarkClass(mark)"/>
                    <b-form-input type="range" number v-model="modulation" min="-1" max="1" v-b-tooltip.noninteractive.hover :title="modulation" :class="Variant" />
                </b-col>
                <b-col>
                    <!-- $t('Cancel') / Annuler -->
                    <b-button @click="close(); visible = false; resetQuizz()" pill :variant="'outline-' + Variant" class="mx-1">{{$t('Cancel')}}</b-button>
                    <span id="disabledCheck" class="d-inline-block" tabindex="0">
                        <!-- $t('Validate') / Valider -->
                        <b-button @click="ok(); updateValue();  visible = false;" pill :variant="Variant" :disabled="isFormDisabled()">{{$t('Validate')}}</b-button>
                    </span>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { mixins } from 'vue-class-component';
    import { Component, Prop, Watch, Vue} from "vue-property-decorator";
    import { Getter } from 'vuex-class';
    import { API_URL } from '@/App.settings';
    import FormField from "@/types/fields/FormField";
    import MarkField from "@/types/fields/MarkField";
    import axios from 'axios';
    import Dictionary from '@/types/Dictionary';
    import Quizz from '@/types/fields/Mark/Quizz';
    import BaseQuestion from '@/types/fields/Mark/BaseQuestion';
    import QuizzTypeEnum from "@/enums/QuizzTypeEnum";
    import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
    import DateField from "@/types/fields/DateField";
    import IFormElement from '@/interfaces/IFormElement';
    import { MarkUtils, ThemeUtils } from '@/components/commons/Utils';
    import locales from './locales/Mark.json';

    /** Composant d'affichage du formulaire de notes  */
    @Component({ i18n: { messages: locales } })
    export default class Mark extends mixins(MarkUtils, ThemeUtils) {
        /** Pour pouvoir utiliser les enums dans la section template */
        private quizzTypeEnum = QuizzTypeEnum;
        private fieldTypeEnum = FieldTypeEnum;

        @Getter('ObjectStore/GetNodeObjectType')
		private nodeObjectType!: string;

        /** Permet d'afficher ou non la modale */
        public visible: boolean = false;

        /** Variant de couleur à appliquer sur le composant */
		@Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public MarkField !: FormField;

        /** Type de formulaire (ConditionForm, EfficiencyForm, ...) */
        private formType :string = "";

        /** Objet correspondant au questionnaire */
        private quizz : Quizz = {} as any;

        /** Note du questionnaire par défaut (min à 1 et max à 10) */
        private mark: number = 0;

        /** Modulation de la note (de -1 à 1) */
        private modulation: number = 0;

        /** Chaine correspondant aux éléments sélectionnés dans le questionnaire */
        private answerStream: string = "";

        private notModulateValue : number = 0;

        /** Correspond à answerStream découpé de la façon suivante => [id_question] = value */
        private initials : Dictionary<any> = {}; 

        /** Objet correspondant à la sélection des checkboxes/radiobutton liés à une question pour réafficher les valeurs */
        private questionSelections : Dictionary<any> = {};

        /** Age de l'objet (selon date d'installation) */
        private age : number = 0;

        /** Valeur de résistance thermique (type de question Param) */
        private rth : number = 0;

        /** Détermine si le formulaire est valide */
        private isDisabled : boolean = false;

        /** Permet l'affichage de la modale et charge le qustionnaire */
        public Show() {
            this.visible = true;
            
            this.formType = (this.MarkField as MarkField).QuizzForm;
            this.answerStream = (this.MarkField as MarkField).Value.AnswerStream;

            this.initials = JSON.parse(JSON.stringify({}));
            this.questionSelections = JSON.parse(JSON.stringify({}));
            
            if(this.MarkField.Name == 'EfficiencyMark')
                this.mark = 1; 

            // Si une réponse est déjà renseignée (questionnaire déjà rempli auparavant)
            if((this.MarkField as MarkField).Value && this.answerStream){
                let result = this.answerStream.split('|');
                // suppression élément correspondant à l'identifiant du questionnaire (on possede déjà cette info)
                result = result.slice(1);

                for (let i = 0; i < result.length; i++) {
                    if(i == 0)
                        this.modulation = Number(result[i]);
                    else
                    {
                        let element : string[] = result[i].split('=');
                        this.initials[element[0]] = element[1];
                    }
                }

                console.debug("Mark - Show - initials : %O", this.initials);
            }

            // Charge l'affichage du questionnaire
            this.loadQuizz();
        }

        /**
         * Watcher permettant le chargement des valeurs initiales pour la sélection (tableau vide en cas de valeurs initiales non présentes)
         */
        @Watch('quizz')
        private loadInitials(){
            console.debug("Mark - loadInitials : %O ", this.initials);
            if(Object.keys(this.initials).length > 0){
                Object.keys(this.initials).forEach( (el) => {
                    Vue.set(this.questionSelections, el, String(this.initials[el]).split(","));
                })
            }
            else if (this.quizz.Questions){
                this.quizz.Questions["BaseQuestions"].forEach( (el) => {
                    Vue.set(this.questionSelections, el.Id, []);
                });
            }
        }

        /** Permet de réinitialiser le questionnaire à la fermeture de la modale*/
        private resetQuizz(){
            this.quizz = {} as any;
            this.age = 0;
            this.modulation = 0;
        }

        /** Charge le questionnaire */
		private loadQuizz(){
			console.debug("Mark - loadQuizz() - MarkField", this.MarkField.Name);
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["FormType"] = this.formType;

            axios.post(API_URL + "object/" + this.nodeObjectType + "/CreateFormMark", args).then((response) => {
                if(response)
                    console.debug("Mark - loadQuizz() - response.data", response.data);
                    this.quizz = response.data;
            });
		}

        /**
         * Permet de récupérer la valeur du label selon sa référence 
         * @param question question
         * @param labelRef référence de label
         */
        private getLabel(question : BaseQuestion , labelRef : string){
            let label = this.quizz.Labels.find(x => x.Id == labelRef).Value;

            // Si on est sur une question param, on effectue des changements
            if(question.Type == "param"){
                // Date d'installation - param type 'age'                 
                let installationDate : IFormElement = this.$store.getters["ObjectStore/GetFormElement"]({ elementName: 'InstallationDate', type: 'Field' }) //this.form("Identity");
                console.debug("Mark - getLabel - installationDate : ", installationDate);

                // Permet de calculer l'age de l'équipement
                if(installationDate){
                    let today = new Date();
                    
                    let date = (installationDate as DateField).Value;

                    console.debug("Mark - getLabel - date : ", date);

                    if (date && date.toString() != "") {
                        let oneYear = 1000 * 60 * 60 * 24 * 365;
                        let difference = today.getTime() - new Date(date).getTime();
                        this.age = Math.trunc(difference / oneYear);
                
                        console.debug("Mark - getLabel - age", this.age);
                    }

                    this.questionSelections["age"] = this.age;

                    console.debug("Mark - getLabel - this.questionSelections", this.questionSelections);

                    label = label.replace("{0}", this.age.toString());
                }
                

                // Type de contact - param type 'Rth'
            }

            return label;
        }

        /**
         * détermine si le formulaire est valide ou non
         */
        private isFormDisabled(){
            this.isDisabled;
            this.questionSelections;
            let questions = this.quizz.Questions;

            if(questions){
                let selection = Object.values(this.questionSelections);

                let hasParamQuestion = questions["BaseQuestions"].findIndex(x => x.Type == 'param');

                console.debug("Mark - isFormDisabled - hasParamQuestion : %O | selection : %O", hasParamQuestion, selection);

                // si y a une question param, on supprime le dernier élement qui correspond à la partie param (age ou Rth)
                if(hasParamQuestion != -1){
                    selection.pop();
                }
                    
                console.debug("Mark - isFormDisabled - selection : %O | selection.length : %O ", selection, selection.length);

                // Si il y a un seul élément qui n'a pas de réponse, le bouton est désactivé
                this.isDisabled = selection.some(x => x.length == 0);
            }
            
            console.debug("Mark - isFormDisabled - isDisabled : %O ", this.isDisabled);
            return this.isDisabled;
        }

        /** Mise à jour de la note */
        @Watch('modulation')
        @Watch('questionSelections', {deep : true})
        protected calculus(){
            console.debug("Mark - calculus - questionSelections : %O | quizz.Questions", this.questionSelections, this.quizz.Questions);

            if(this.quizz.Questions){
                let param : string = "";
                let answer : string = this.quizz.Id + "|" + this.modulation;
                let marks : number[] = [];

                // Récupération des notes pour chaque type de question
                for(let q of this.quizz.Questions['BaseQuestions']){

                    console.debug("Mark - calculus - question : %O | answer : %O", q.Type, answer);

                    let items = q.Items;
                    let group = this.questionSelections[q.Id];
                    let groupMark = 0;
                    switch(q.Type){
                        case "radiobuttons":
                            if(this.questionSelections[q.Id]){
                                let item = items.find(x => x.Id == this.questionSelections[q.Id]);
                                let value : number = 0;

                                if(item)
                                    value = Number(item.Value);

                                marks.push(value);
                                answer += "|" + q.Id + "=" + this.questionSelections[q.Id];
                            }
                            break;
                        case "conditionalradiobuttons":
                            if(this.questionSelections[q.Id]){
                                let item = items.find(x => x.Id == this.questionSelections[q.Id]);
                            
                                if(item){
                                    let questionRef = item.QuestionRef;
                                    let question = this.quizz.Questions['BaseQuestions'].find(x => x.Id == questionRef);
                                    let markRef = this.questionSelections[questionRef];
                                    let markItems = item.If;

                                    for (let i = 0; i < markItems.length; i++) {
                                        if(markItems[i].SelectedItemId == markRef)
                                            marks.push(parseInt(markItems[i].Value));
                                    }    
                                }
                                answer += "|" + q.Id + "=" + this.questionSelections[q.Id];
                            }
                            break;
                        case "checkboxes":
                            groupMark = 0;
                            
                            if(group){
                                let serialMark = "|" + q.Id + "=";
                                for (let i = 0; i < group.length; i++) {
                                    let value = items.find(x => x.Id == group[i]).Value;
                                    groupMark += value;
                                    if(i == 0)
                                        serialMark += group[i];
                                    else
                                        serialMark += "," + group[i];
                                }
                                marks.push(groupMark);
                                answer += serialMark
                            }    
                            break;
                        case "conditionalcheckboxes":
                            groupMark = 0;
                            if(group){
                                let serialMark = "|" + q.Id + "=";

                                for (let i = 0; i < group.length; i++) {
                                    let item = items.find(x => x.Id == group[i]).Value;
                                    let markRef = item.QuestionRef;
                                    let markItems = item.If;
                                    for (let j = 0; j < markItems.length; j++) {
                                        if(markItems[j].SelectedItemId == markRef)
                                            groupMark += parseInt(markItems[j].Value)
                                    }
                                    if(i == 0)
                                        serialMark += group[i];
                                    else
                                        serialMark += "," + group[i];
                                }
                                marks.push(groupMark);
                                answer += serialMark;
                            }
                            break;
                        case "decreasingSum":
                            groupMark = 10;

                            if(group){
                                let serialMark = "|" + q.Id + "=";
                                for (let i = 0; i < group.length; i++) {
                                    let value = items.find(x => x.Id == group[i]).Value;
                                    groupMark -= value;
                                    if(i == 0)
                                        serialMark += group[i];
                                    else
                                        serialMark += "," + group[i];
                                }
                                answer += serialMark;
                            }
                            marks.push(groupMark);
                            break;
                        case "param":
                            let markUnder : number = 0;
                            switch(q.Param.Name){
                                case "age":
                                    markUnder = this.getMarkUnders(q.Param.Unders, q.Param.Over, this.age);
                                    marks.push(markUnder);
                                    param = "|age=" + this.age;
                                    break;
                                case "Rth":
                                    switch(this.nodeObjectType){
                                        case "Equipment_Wall":
                                            //this.rth = 1 
                                        break;
                                        case "Equipment_Roofing":
                                            //this.rth =
                                        break;
                                        case "Equipment_Floor":
                                            //this.rth =
                                        break;  
                                    }

                                    markUnder = this.getMarkUnders(q.Param.Unders, q.Param.Over, this.rth);
                                    marks.push(markUnder);
                                    param = "|Rth=" + this.rth;
                                    break;
                            }
                            answer += "|" + q.Id + "=" + markUnder;
                            this.questionSelections[q.Id] = markUnder;
                            break;
                    }
                }
                console.debug("Mark - calculus - marks : %O - answer ! %O ", marks, answer);
                answer += param;

                let result : number = 0;
                // Calcul de la note selon le type de questionnaire
                switch(this.quizz.Type){
                    case QuizzTypeEnum.sum:
                        result = 0;
                        for(let m of marks){
                            result += m;
                        }
                        break;
                    case QuizzTypeEnum.decrease:
                        result = 10;
                        for(let m of marks){
                            result += m;
                        }
                        break;
                    case QuizzTypeEnum.sumDividedBy10:
                        result = 0;
                        for(let m of marks){
                            result += m;
                        }
                        result = Math.round(result / 10);
                        break;
                    case QuizzTypeEnum.minimum:
                        result = 10;
                        for(let m of marks){
                            if(result > m)
                                result = m;
                        }
                        break;
                    case QuizzTypeEnum.sumMore10:
                        result = 0;
                        for (let m of marks) {
                            result += m;
                        }
                        result += 10;
                        break;
                }
                console.debug("Mark - calculus - result : %O", result);
                // Normalisation du résultat avant et apres ajout modulation dans le résultat ( result < 1 => 1 | result > 10 => 10)
                
                result = this.normaliseResult(result);
                console.debug("Mark - calculus - result - 1ere norma : %O | result + modulation : %O", result, result + Number(this.modulation));
                this.notModulateValue = result;
                result += this.modulation;
                result = this.normaliseResult(result);
                console.debug("Mark - calculus - result - 2nde norma : %O ", result);
                this.mark = result;

                // Changement de la chaine de réponse
                this.answerStream = answer;
            }
        }

        private updateValue(){
            // AnswerStream - modulation - mark
            this.MarkField.Value = {
                AnswerStream : this.answerStream,
                Modulation: this.modulation,
                NorModulatedMark : this.notModulateValue,
                Value : this.notModulateValue + this.modulation
            } 
        }

        /**
         * Permet de retourner la note en comparant la value avec les unders (valeurs inférieures) et l'over (valeur supérieure)
         * @param unders liste des valeurs inférieures
         * @param over valeur supérieure
         * @param value valeur à comparer
         */
        private getMarkUnders(unders, over, value) : number{
            console.debug("Mark - getMarkUnders - unders : %O | over : %O | value : %O", unders, over, value);

            for(let under of unders){
                if(value <= under.Value){
                    return Number(under.Mark);
                }
            }

            return Number(over.Mark);
        }

        /**
         * Permet de normaliser le résultat pour qu'il reste entre 1 et 10
         * @param result resultat à traiter 
         */
        private normaliseResult(result : number){
            if(result < 1)
                result = 1;
            else if (result > 10)
                result = 10;

            return result;
        }
    }
</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }
</style>